import { createContext, useCallback, useContext, useState } from 'react'
import type { PropsWithChildren } from 'react'
import {AnnouncementType, ErrorEnum, getAnnouncement} from '@/utils/announcements'

interface AnnouncementsContextValue {
  announcements: AnnouncementType[]
  addAnnouncement: (type: ErrorEnum) => void
  removeAnnouncement: (type: ErrorEnum) => void
}

export const AnnouncementsContext = createContext<AnnouncementsContextValue>({
  announcements: [],
  addAnnouncement: () => {},
  removeAnnouncement: () => {},
})

export const AnnouncementsProvider = ({ children }: PropsWithChildren) => {
  const [announcements, setAnnouncements] = useState<AnnouncementType[]>([])

  const addAnnouncement = useCallback((type: ErrorEnum) => {
    const announcement = getAnnouncement(type)
    setAnnouncements((prev) => {
      if (prev.find((a) => a.id === announcement.id)) return prev
      return [...prev, announcement].sort((a, b) => ((a as any).priority || 0) - ((b as any).priority || 0))
    })
  }, [setAnnouncements])

  const removeAnnouncement = useCallback((type: ErrorEnum) => {
    const announcement = getAnnouncement(type)
    setAnnouncements((prev) => prev.filter((a) => a.id !== announcement.id))
  }, [setAnnouncements])

  return (
    <AnnouncementsContext.Provider value={{ announcements, addAnnouncement, removeAnnouncement }}>
      {children}
    </AnnouncementsContext.Provider>
  )
}

export const useAnnouncementsContext = () => useContext(AnnouncementsContext)